import "./assets/main.css";

import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";

//Plugins
import "./plugins";
import i18n from "./i18n";
import filters from "./filters";

Vue.config.productionTip = false;
Vue.use(filters);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
